var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tagList.length > 0)?_c('div',{staticClass:"overflow-menu"},_vm._l((_vm.tagList),function(tag){return _c('a',{key:tag,staticClass:"tag"},[_vm._v("#"),_c('span',[_vm._v(_vm._s(tag))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }